var map = {
	"./assets/images/close.svg": "./assets/images/close.svg?8333",
	"./assets/images/default-image-author.svg": "./assets/images/default-image-author.svg",
	"./assets/images/default-image-post-card.svg": "./assets/images/default-image-post-card.svg",
	"./assets/images/favicon/android-chrome-192x192.png": "./assets/images/favicon/android-chrome-192x192.png",
	"./assets/images/favicon/android-chrome-512x512.png": "./assets/images/favicon/android-chrome-512x512.png",
	"./assets/images/favicon/apple-touch-icon.png": "./assets/images/favicon/apple-touch-icon.png",
	"./assets/images/favicon/favicon-16x16.png": "./assets/images/favicon/favicon-16x16.png",
	"./assets/images/favicon/favicon-32x32.png": "./assets/images/favicon/favicon-32x32.png",
	"./assets/images/spinner.svg": "./assets/images/spinner.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./. sync recursive \\.(jpg%7Cpng%7Cgif%7Csvg)$";